<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 10"
    fill="none"
  >
    <path d="M0 6.06404C0 2.62404 3 -0.295957 7 0.0240416V2.18404C4.76 2.10404 3.16 3.18404 2.8 4.94404C3.12 4.82404 3.44 4.78404 3.72 4.78404C5.24 4.78404 6.32 5.90404 6.32 7.30404C6.32 8.86404 5.12 9.94404 3.36 9.94404C1.24 9.94404 0 8.38404 0 6.06404ZM8.52 6.06404C8.52 2.62404 11.52 -0.295957 15.52 0.0240416V2.18404C13.28 2.10404 11.68 3.18404 11.32 4.94404C11.64 4.82404 11.96 4.78404 12.24 4.78404C13.72 4.78404 14.84 5.90404 14.84 7.30404C14.84 8.86404 13.6 9.94404 11.88 9.94404C9.76 9.94404 8.52 8.38404 8.52 6.06404Z" fill="currentColor" />
  </svg>
</template>
